import { Directive, HostListener, ElementRef, Inject, forwardRef, Optional, OnDestroy, OnInit, Input } from '@angular/core';
import { TileComponent } from '../components/tile.component';
import { DashboardComponent } from '../components/dashboard.component';
import { TileContainer } from '../services/TileContainer';
import { TileDescriptor } from '../services/TileDescriptor';
import { Subject } from 'rxjs';

@Directive({
  selector: '[plrTileNavigation]'
})
export class TileNavigationDirective implements OnInit, OnDestroy {
  destroyed$: Subject<boolean> = new Subject<boolean>();
  parent: any;
  button: any;

  @Input('plrTileNavigation')
  tileComponent: TileComponent;

  constructor(@Optional() private tile: TileComponent,
    @Optional() private tileContainer: TileContainer,
              private elementRef: ElementRef) {
    elementRef.nativeElement.tabIndex = 0;
  }

  ngOnInit(): void {
    var button = document.createElement("button");
    button.tabIndex = 0;
    button.style.background = "transparent";
    button.style.border = "transparent";
    button.style.width = "5px";
    button.style.height = "0px";
    button.setAttribute('aria-label', 'Skip to next tile');
    button.addEventListener("click", () => this.onArrowRight());
    this.parent = this.elementRef.nativeElement.parentNode;
    this.button = button;
    this.parent.insertBefore(this.button, this.elementRef.nativeElement.nextSibling);
    if (this.tileComponent) {
      this.tile = this.tileComponent;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    if (this.button) {
      this.parent.removeChild(this.button);
      this.button = undefined;
      this.parent = undefined;
    }
  }

  private moveFocus(direction: number) {
    if (!this.tileContainer.tileComponents || this.tileContainer.tileComponents.length <= 1) {
      return;
    }
    var foundTile = false;
    var nextTile: TileComponent = undefined;
    var previousTile: TileComponent = undefined;
    if (this.tileContainer.tileComponents && this.tileContainer.tileComponents.length) {
      for (var i = 0; i < this.tileContainer.tileComponents.length; i++) {
        if (foundTile) {
          nextTile = this.tileContainer.tileComponents[i];
          break;
        }
        if (this.tileContainer.tileComponents[i] === this.tile) {
          foundTile = true;
        } else {
          previousTile = this.tileContainer.tileComponents[i];
        }
      }
      if (foundTile) {
        var focusTile = nextTile;
        if (direction === -1) {
          focusTile = previousTile;
        }
        if (!focusTile) {
          if (direction === -1) {
            focusTile = this.tileContainer.tileComponents[this.tileContainer.tileComponents.length - 1];
          } else {
            focusTile = this.tileContainer.tileComponents[0];
          }
        }
        if (focusTile) {
          focusTile.setFocus();
        }
      }
    }
  }

  @HostListener('keydown.ArrowLeft', ['$event.target'])
  onArrowLeft() {
    this.moveFocus(-1);
  }

  @HostListener('keydown.ArrowRight', ['$event.target'])
  onArrowRight() {
    this.moveFocus(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/directives/tile-navigation.directive.ts